import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYoutube } from "@fortawesome/free-brands-svg-icons"
import { Button, ButtonGroup, PageHeader, PanelGroup, Panel, Modal } from "react-bootstrap";
import { getExistingAthleteMetrics, begin1RMCalc, setNew1RM }from "../../utils/AthleteMetrics";
import { getMeasureTitle }          from "../../utils/Measure";
import { get1RepMax, getPercent1RM }from "../../utils/OneRM";
import { ExerciseFreeFormId }       from "../../utils/StaticIds";
import StopWatch                    from "../../components/StopWatch";
import uniqueId                     from "lodash/uniqueId";
import LoaderButton                 from "../../components/LoaderButton";
import WorkoutFinishedBox           from "../../components/workout/WorkoutFinishedBox";
//import YouTubeThumbnail             from "../../components/YouTubeThumbnail";
import YouTubePlayer                from "../../components/YouTubePlayer";
import PanelMeasureAddSubtract      from "../../components/PanelMeasureAddSubtract";
import SaveAllExerciseRow           from "../../components/workout/SaveAllExerciseRow";
import LinkHistory                  from "../../components/LinkHistory";
import PanelHeaderBkgrd             from "../../images/utils/panel_header_bkgrd.png";
import ModalExerciseNotes           from "../../components/modal/ModalExerciseNotes";
import ModalExerciseAthleteNotes    from "../../components/modal/ModalExerciseAthleteNotes";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import ModalLoadingInfo             from "../../components/modal/ModalLoadingInfo";
import { invokeGetWorkoutAllExerciseMetrics,
         invokeSetAthleteExerciseMetrics,
         invokeSetAthleteExerciseMetricsSaveAll,
         invokeSetAthleteExerciseSaveAllMetricsVers2
       } from "../../utils/AwsInvoke";

import { Steps, Hints }             from "intro.js-react"; // js code for welcome tour

import "intro.js/introjs.css"; // css for welcome tour
import "../../css/workout/WorkoutMetrics.css";


const uuidv4        = require('uuid/v4');
var white_label     = WhiteLabel();
const MainColor     = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;
const AWSUrl                    = white_label.aws_athlete_assets_url;
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
var congrats_txt;

// Capture data in global vals for the "Save All" button;
// Can't add in SetState otherwise there's an endless loop
// Below is a temp solution, replace shortly
var save_all_exercise_vals = [];
var save_all_exercise_1rm  = [];
var save_all_key_ctr_block_ids = [];

var total_blocks           = 0;
var total_completed_blocks = 0;
var exercise1RM_arr        = [] //track the current day's existing 1rm arrays

var track_measure_psmv_id_arr     = []; // track all psmv ids to track when a Set is completed
var track_compl_set_ids_per_block = [];
var track_total_set_ids_per_block = [];

//var page_overlay        = "none";
var workout_box_overlay = "none";
// Ensure all elements/values in an array is the same
// Used to ensure all reps are the same to calculate 1RM
const allEqual = arr => arr.every( v => v === arr[0] )

export default class WorkoutAllExercises extends Component {
    constructor(props) {
        super(props);

        var week_day      = `${this.props.match.params.week_tracker}`;
        var week          = week_day.substring(0, 1);
        var day           = week_day.substring(2, 3);
        var curr_week_day = "Week " + week + ", Day " + day;

        this.state = {
            title:        `${this.props.match.params.title}`,
            program_id:   `${this.props.match.params.program_id}`,
            day_id:       `${this.props.match.params.day_id}`,
            week_tracker:  curr_week_day,
            curr_week:     week,
            curr_day:      day,
            activeKey:     1,
            showModalExerciseNotes: false,
            showModalLoadingInfo:  false,
            isLoading: true,
            list: [],
            cover_title: "",
            closeOverlay: false,
            showModalExerciseAthleteNotes: false,
            showBodyPanelOverlay: "none",
            pageOverlay: "none",
            loadingText: "Loading exercises ...",
            //exercise1RMArr: []

            // Help Tour //
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                  element: ".programDayWorkoutExerciseButtonBarProductTour",
                  intro:   "Select a \"view\" and how you would like to see your workout. <b>\"View Single Exercise\"</b> shows you one exercise at a time.  <b>\"View All Exercises\"</b> shows all exercises on one screen.",
                  position: 'left'
              },
              {
                  element: ".workoutAllExercSaveAllCMarkProductTour",
                  intro:   "Save all exercises in a block.",
                  position: 'auto'
              },
              {
                  element: ".workoutAllExercAthleteNotesProductTour",
                  intro:   "Save all your personal notes about the exercise here.",
                  position: 'auto'
              },
              {
                  element: ".workoutAllExercPanelTitleProductTour",
                  intro:   "Click on the \"set\" bar to expand and view the exercise details.",
                  position: 'auto'
              },
              /*{
                  element: ".workoutDetailPanelSubtractProductTour",
                  intro: "-----",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelTextfieldProductTour",
                  intro: "input",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelAddProductTour",
                  intro: "++++++",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelSaveBtnProductTour",
                  intro: "Save button!",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailSaveAllProductTour",
                  intro: "Save all",
                  position: 'auto'
              },*/
              {
                  element: ".workoutAllExerc1RMHistoryProductTour",
                  intro: "See your 1 Rep Max and workout history for this specific exercise.",
                  position: 'auto'
              },
              {
                  element: ".workoutAllExercYouTubeProductTour",
                  intro: "See how to perform the exercise by video via Youtube.",
                  position: 'auto'
              },
            ],
        };
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated)
            return;

        try {
            //page_overlay = "none";
            workout_box_overlay = "none";
            this.renderExerciseSetList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }

    async renderExerciseSetList() {
        this.setState({ showModalLoadingInfo: true });
        var user_id     = this.props.globalUserId;
        var day_id      = this.state.day_id;
        var program_id  = this.state.program_id;
        var results     = await invokeGetWorkoutAllExerciseMetrics(user_id, day_id, program_id);
        exercise1RM_arr = []; // reset the tracking of 1rm exercise arrays
        save_all_key_ctr_block_ids = [];
        workout_box_overlay = "none";

        if(results.status) {
            var data = results.data;
            // Default setting
            var title            = this.state.title; //"Workout";
            var panel_key        = 1;
            var list             = data.blocks;
            var names            = data.names;
            var metric_data      = data.metric_data;
            var completed_blocks = data.completed_blocks;
            var athlete_metrics  = results.data.athlete_metrics;
            var youtube_ids      = results.data.exercise_details;
            var exercise_notes   = results.data.exercise_notes;

            var free_form_notes = "";//results.data.exercise_details.notes; // for FreeForm exercises
            var exercise_one_rm = results.data.oneRM;
            var exercise_ids_in_notes = [];

            //  get exerc ids in notes  //
            for(var key in exercise_notes) {
                var exercise_id = exercise_notes[key][0]; //[0] = exerc id; [1] = notes
                exercise_ids_in_notes.push(exercise_id) // match exerc ids with notes
            }

            this.setState({
                user_id:              user_id,
                list:                 list,
                cover_title:          title,
                names:                names,
                metric_data:          metric_data,
                exerciseNotes:        exercise_notes,
                exerciseIdsInNotes:   exercise_ids_in_notes,
                completed_blocks:     completed_blocks,
                free_form_notes:      free_form_notes,
                athlete_metrics:      athlete_metrics,
                perm_athlete_metrics: athlete_metrics,
                activeKey:            "0", //active_key
                exercise_1rm:         exercise_one_rm,
                yt_ids:               youtube_ids,
                showModalLoadingInfo: false,
                curr_yt_id:           ""
            })

            this.setState({ isLoading: false });
        }
    }

    handleWorkoutFinished = event => {
          event.preventDefault();
          var title         = this.state.title;
          var week_tracker  = this.state.week_tracker;
          var program_id    = this.state.program_id;
          var day_id        = this.state.day_id;
          var curr_week     = this.state.curr_week;
          var curr_day      = this.state.curr_day;

          this.props.history.push(`/workoutFinished/${title}/${curr_week}-${curr_day}/${program_id}/${day_id}`);
  }

    renderAllExercisesList(list) {

        if(list != undefined) {
            var cover_title  = this.state.cover_title;
            var day_id       = this.state.day_id;
            var week_tracker = this.state.week_tracker;
            var program_id   = this.state.program_id;
            var curr_week    = this.state.curr_week;
            var curr_day     = this.state.curr_day;
            var image2;
            var company_id     = localStorage.getItem('globalUserCompanyId');


            var cover_image = localStorage.getItem('coverImage');

            if(cover_image != undefined)
                image2 = <img src={ cover_image } width="100%"/> //require(`../../images/program_categories/`+image)

            //} else if(image != undefined)
            //    image2 = <img src={require(`../../images/program_categories/`+image)} height="220" width="100%"/>


            //// BEGIN: The actual marketplace_prog_id is not needed here
            //// because the id is only used when creating a new program day
            //// so, the
            var mktplc_program_id = 0;

            var programs = <span className="workoutDetailsContainer" >

                                        <span className="programBeginImage" style={{backgroundColor: "#666"}}>
                                             { image2 }
                                        </span>
                                        <span className="programWorkoutFadeImage">
                                            <img src={require('../../images/utils/program_category_black_fade2.png')} height="105" width="100%"/>
                                        </span>
                                        <span className="programWorkoutTitle"
                                              href={`/ProgramBegin/${program_id}/${cover_title}`}
                                              onClick={this.handleWorkoutDetails}
                                              style={{position: "absolute", top:16, whiteSpace: "nowrap", overflowX:"hidden", color: "#fff", cursor: "pointer", zIndex:1000}}
                                        >
                                            {cover_title}
                                        </span>
                                        <span className="programWorkoutDateTitle"
                                              style={{position: "absolute", top:58, fontSize:"24px", color: "#fff"}}
                                              >
                                              {week_tracker}
                                        </span>
                                        <div style={{position:"relative", top: 77, zIndex:1000}}>
                                            <ButtonGroup size="lg"
                                                         style={{width:"100%", position:"relative", top:70, left: -10}}
                                                         className="workoutOverviewLink dayViewBtnGroup dayViewFlex programDayWorkoutExerciseButtonBarProductTour">
                                                <Button  href={`/programDayWorkout/${program_id}/${day_id}/${cover_title}/${curr_week}-${curr_day}/${mktplc_program_id}`}
                                                         onClick={this.handleExerciseMetrics}
                                                         className="buttonWorkoutMode dayViewBtn">
                                                    Single Exercise
                                                </Button>
                                                <Button className="active buttonWorkoutMode dayViewBtn">
                                                    All Exercises
                                                </Button>
                                                { /*}<Button className="buttonWorkoutMode dayViewBtn">
                                                    Grid View <span style={{fontSize:10}}>(coming...)</span>
                                                </Button>*/ }
                                            </ButtonGroup>
                                        </div>
                                    <span className="workoutMetricsSummary">
                                        { this.renderWorkoutList() }
                                    </span>
                                    <div style={{display: "inline-block", width: "100%", position: "relative", top: 10}}>
                                        {
                                            ////  Completed blocks and Total blocks both start out as 0  ////
                                            (total_completed_blocks > 0 && total_completed_blocks >= total_blocks) ?
                                                congrats_txt = <div style={{position:"relative", marginLeft:"50%", left: -200}}>
                                                                    { /*}<WorkoutFinishedBox
                                                                        isLoading = {this.state.isLoading}
                                                                        color     = "#666"
                                                                        handleWorkoutFinished = {this.handleWorkoutFinished}
                                                                   />*/ }
                                                               </div>
                                                : congrats_txt = ""
                                        }
                                    </div>
                                    { /*}<span className="beginBtnFooter"
                                          href={`/workout`}
                                          onClick={this.handleGenericClick}>
                                        <span className="glyphicon glyphicon-time beginGlyphIcon"/>01:00
                                    </span> */ }
                            </span>
        }

        ////  Show Overlay with Workout finished button  ////
        if(total_completed_blocks > 0 && total_completed_blocks >= total_blocks){
            //page_overlay = "inline";
            if(this.state.showWorkoutBox != "inline" && workout_box_overlay === "inline") {
                this.setState({
                    showWorkoutBox: "inline"
                })
            }
            workout_box_overlay = "inline";
        }

        total_completed_blocks = 0;

        return programs;
    }
    handleExerciseMetrics = event => {
        event.preventDefault();
        var href = event.currentTarget.getAttribute("href");
        this.props.history.push(href);
    }

    handleGenericClick = event => {
      event.preventDefault();
      this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>TS</h1>
                <p></p>
            </div>
        );
    }

    handleSelect (activeKey) {
        this.setState({ activeKey });
    }

    createMarkup(text) { return {__html: text}; };

    renderList() {
        return (
            <div className="list">
                {!this.state.isLoading && this.renderAllExercisesList(this.state.list)}
            </div>
        );
    }

    ////  Function is used for both  1RM  AND   Predictive Loading
    getOneRepMax = (exercise_id, todays_date) => {
        //console.log("1. getOneRepMax >>>>>>>>>>>>>>>>>> >>>>>>>>>>>> !!!");
        var tmp_one_rep_max;
        //var exercise_id = "16a464e3-90f7-4553-a421-7bb64a4a630e";
        var one_rep_max_obj = this.state.exercise_1rm;

        var tmp_one_rep_max = 0;
        var tmp_val     = 0;
        // exercise1RM_arr = []
        for(var key in one_rep_max_obj) {

            var tmp_exercise_id = one_rep_max_obj[key].exercise_id;

            if(tmp_exercise_id === exercise_id) {
                tmp_one_rep_max = one_rep_max_obj[key].one_rep_max;
                var dateString = one_rep_max_obj[key].date_created;

                var new_date = new Date(dateString.replace(' ', 'T'));
                var tmp_month = new_date.getMonth()+1;
                var tmp_day   = new_date.getDate();
                var tmp_year  = new_date.getFullYear();
                var created_date = tmp_month+"-"+tmp_day+"-"+tmp_year;

                // USE for 1RM
                if(todays_date === created_date) {
                    exercise1RM_arr.push([exercise_id, tmp_one_rep_max]);
                }

                //console.log("exercise_id: " + exercise_id);

                if(parseInt(tmp_one_rep_max) > parseInt(tmp_val)) {
                    tmp_val = tmp_one_rep_max;
                }
            }
        }

        return tmp_val; //tmp_one_rep_max;
    }

    saveSingleSetMetricData = async (set_id, exercise_id, set_number, measure_id, metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, panel_group_ctr, block_id) => { //, callback) => {
        //var exercise1RMArr = this.state.exercise1RMArr;

        var user_id       = this.props.globalUserId;
        var program_id    = this.state.program_id;
        var one_rep_max   = 0;
        var screen        = "workoutMetrics";
        var set_completed = false;
        var total_psmvs   = 0;

        ////  SET COMPLETED PROGRAM SETS   ////

        //// track_measure_psmv_id_arr holds the total number of completed psmv ids,
        //// which will be compared with the total number completed
        var psmv_exists   = track_measure_psmv_id_arr.indexOf(psmv_id);
        var total_set_ctr = 0;
        var total_ids     = track_measure_psmv_id_arr.length;
        var set_lgth      = track_total_set_ids_per_block.length;

        //// Get Total number of COMPLETED SETS per this SET ID that were checked already  ////
        for(var h=0;h < total_ids; h++) {
            var tmp_compl_set_id = track_compl_set_ids_per_block[h]

            if(tmp_compl_set_id === set_id) {
                total_set_ctr++;
            }
        }

        var base_total_sets = 0;
        var psmv_id_lgth = 0;

        ////  Find out how many TOTAL SETS there are on this page via the multi-dim array  ////
        for(var i=0;i < set_lgth; i++) {
            var tmp_set_id = track_total_set_ids_per_block[i][0];

            if(tmp_set_id === set_id) {
                base_total_sets = track_total_set_ids_per_block[i][1];
                break;
            }
        }

        //// Add 1 if psmv id is not included in the completed ids array,
        //// this will then be compared with the completed array; if the user is just resaving data, do not +1
        if(psmv_exists == -1) {
            //psmv_id_lgth = track_measure_psmv_id_arr.length;
            total_set_ctr = total_set_ctr + 1;
        } /*else {
            ////  If the psmv id exists, use the current array length to get total number of completed exercise sets (psmvs)
            total_psmvs = total_set_ctr;
        }*/

        if(parseInt(total_set_ctr) >= parseInt(base_total_sets)) {
            //console.log(" !!!!!!!!!!!!!!!  EXERCISE COMPLETED !!!!!!!!!!!!!!!");
            set_completed = true;
        }

        ////// GET New 1RM Value ////
        var obj1RM   = begin1RMCalc(one_rep_max, metric_a_id, metric_b_id,  metric_a, metric_b);
        var calc_1rm = obj1RM.calc_1rm; // this determines if the metric id is Reps/Pounds/ or % of Max
        var one_rm   = obj1RM.one_rm;

        // Measure Ids:
        // 2 = Reps
        // 10 = Pounds
        // 12 = Percent of Max (%)
        var tmp_1rm_val;

        var check_exerc_id = false;
        /*if((metric_a_id == 2 && (metric_b_id == 10 || metric_b_id == 12)) ||
           ((metric_a_id == 12 || metric_a_id == 10) && metric_b_id == 2)) {*/
        if(calc_1rm) {

                // not using exercise1RM_arr
                for(var i = 0; i < exercise1RM_arr.length; i++) {

                    if(exercise1RM_arr[i][0] === exercise_id) {
                        // Get existing 1RM value if it exists
                        var existing_1rm_val = exercise1RM_arr[i][1];

                        // Must get default 1RM for exercise, otherwise a 0 will be used and an
                        // incorrect 1RM value will be inserted into the db
                        one_rep_max = existing_1rm_val;
                        check_exerc_id = true;
                        //// Is new 1RM value > than the existing value
                        if(parseInt(one_rm) > parseInt(existing_1rm_val)) {
                            exercise1RM_arr[i][1] = one_rm; // substitute old 1RM with new 1RM
                            one_rep_max = one_rm; // insert into db
                        }
                    }
                }
                ////  Does an Exercise Id exist in the 1RM of array exercises?
                ////  If not, add the new one_rm field
                if(!check_exerc_id) {
                    one_rep_max = one_rm; // insert into db
                    //exercise1RM_arr.push([exercise_id,one_rm])
                }
        }

        /*if(calc_1rm && (parseInt(one_rm) > parseInt(one_rep_max))) {
                one_rep_max = one_rm;
        }*/

        //console.log("one_rm: " + one_rm + " > one_rep_max: " + one_rep_max);

        if((metric_a_id == 2 && (metric_b_id == 10 || metric_b_id == 12)) ||
           ((metric_a_id == 12 || metric_a_id == 10) && metric_b_id == 2) ||
           (metric_a_id == 5 && (metric_b_id == 10 || metric_b_id == 12)) ||
              ((metric_a_id == 12 || metric_a_id == 10) && metric_b_id == 5)) {
            this.setOverlayState("double_overlay");

        } else {
            this.setOverlayState("double_overlay");
        }

        var results  = await invokeSetAthleteExerciseMetrics(screen, user_id, program_id, block_id, set_number, set_id, exercise_id, psmv_id, metric_a, metric_b, metric_a_id, metric_b_id, one_rep_max, set_completed);

        if(results.status) {
            this.renderExerciseSetList();
            this.setOverlayState("no_double_overlay");
        }
    }

    getTotalSets = (new_set_id) => {
        var metric_data = this.state.metric_data;
        var set_ctr = 0;

        for(var key in metric_data) {
                var list2  = metric_data[key];
                var set_id = list2.set_id;

                if(set_id == new_set_id) {
                    set_ctr++;
                }
        }

        return set_ctr/4;
    }

    renderExerciseList (key_ctr, handleCompleteSet, block_id, new_set_id, exercise_id, exercise_name, todays_date){ // measure_id, measure_a, measure_b, measure_c, measure_rest, psmv_id, measure_2_id, measure_3_id, measure_2_title, measure_3_title) {
            var yt_id   = "";
            var metric_data = this.state.metric_data;
            var rest    = 30;//set_key.rest;
            var panel_arr = [];
            var lgth = metric_data.length;

            var measure_1          = []; // # of sets
            var measure_2          = [];
            var measure_2_psmv_ids = []; // rep ids
            var measure_3_psmv_ids = []; // or rep ids
            var measure_2_id;
            var measure_3          = [];
            var measure_3_id;
            var measure_rest       = []; // always REST
            var measure_psm_ids    = [];

            // Clear vars
            var save_all_metric_a_vals = []; // Weight: lbs/kg ; For Predictive Loading, replaces % of Max (id: 12)
            var save_all_metric_b_vals = []; // Mainly used for REPS (row 2 from admin side)

            var save_all_metric_a_ids = [];
            var save_all_metric_b_ids = [];

            var save_all_metric_psmv_ids     = [];
            var save_all_metric_set_ids      = [];
            var save_all_metric_set_numbers  = [];
            var save_all_metric_exercise_ids = [];

            var exerc_arr = [];
            var ctr = 0;

            var total_sets = this.getTotalSets(new_set_id); // 4 = total number of measurements, ie sets/reps/% of max/rest
            /*console.log("----------------------------------");
            console.log("exercise_name: " + exercise_name);
            console.log("exercise_id: " + exercise_id);*/
            var one_rep_max = this.getOneRepMax(exercise_id, todays_date);

            //console.log(">>>>> total_sets: " + total_sets);
            track_total_set_ids_per_block.push([new_set_id, total_sets])

            for(var key in metric_data) {
                    var list2  = metric_data[key];
                    var set_id = list2.set_id;
                    //console.log(key + ". set_id: " + set_id);
                    if(set_id == new_set_id) {
                        // props: uid, measure_id, m_order, val, psmv_uid

                        var val        = list2.val;
                        var psm_id     = list2.psm_id; // uid from program_set_measure table
                        var measure_id = list2.measure_id;
                        var psmv_id    = list2.psmv_id;
                        //console.log("+++++++ START WORKOUT: ALL EXERCISES ______");
                        //console.log("set_id: " + set_id);
                        //console.log("psmv_id: " + psmv_id);
                        //measure_psmv_id
                        if(ctr < total_sets) {
                            //// Static SET Information ONLY ////
                            measure_1.push(val)
                            //console.log("M Order: " + list2.m_order);
                            //console.log("Measure 1 val: " + val);
                        } else if(ctr < total_sets*2){
                            measure_2.push(val);
                            measure_2_psmv_ids.push(psmv_id);
                            measure_2_id = measure_id;
                            //console.log(key + ". psmv_id: " + psmv_id);
                            //console.log("measure_2_id: " + measure_2_id);
                            //console.log("Measure_2_psmv_id: " + psmv_id);
                        } else if(ctr < total_sets*3){
                            measure_3.push(val)
                            measure_3_psmv_ids.push(psmv_id);
                            measure_3_id = measure_id;
                            //console.log("measure_3_id: " + measure_3_id);
                            //console.log("Measure_3_psmv_id: " + psmv_id);
                        } else if(ctr < total_sets*4){
                            // No need for measure id, Will ALWAYS BE REST
                            //console.log("Measure 4 val: " + val);
                            measure_rest.push(val)
                        }
                        measure_psm_ids.push(psm_id); //
                        ctr++;
                        //exerc_arr.push(val)
                    }
            }

            var bg_color       = "#f2f2f2";

            //var group_sets = total_sets/4; // divide by 4 because there are 4 rows/metrics on the admin side

            var measure_2_title = "";
            var measure_3_title = "";
            var current_metrics = this.state.athlete_metrics;
            var perm_athlete_metrics = this.state.perm_athlete_metrics;
            var set_number;
            var tmp_measure_a;
            var tmp_measure_b;
            var same_vals_arr = [];

            ////////////////////////////////////////////////////////////////
            ////    CHECK IF ALL FIELDS HAVE THE SAME SET # for 1RM     ////

            for(var h = 0; h < total_sets; h++) {

                // Measure Ids:
                // 2 = Reps
                // 10 = Pounds
                // 12 = Percent of Max (%)

                //  Track if reps are consistent and all the same   ////
                //  Below, in the if state., ALL repetitions are on the 2nd Row  //
                if(measure_2_id == 2  && measure_3_id == 12 ||
                   measure_2_id == 10 && measure_3_id == 2 ||
                   measure_2_id == 5  && measure_3_id == 12 ||
                   measure_2_id == 10 && measure_3_id == 5) {
                       var measure_psmv_id  = measure_2_psmv_ids[h];
                       var athlete_data     = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                       var measure_reps     = Number(measure_2[h]); //reps_val;
                       var obj_lgth         = Object.keys(athlete_data).length;

                       if(obj_lgth > 0) {
                             measure_reps = Number(athlete_data.metric_b); // ie Reps     = id 2
                       } else {
                             measure_reps = Number(measure_2[h])
                       }

                       same_vals_arr.push(measure_reps)

                } else if(measure_2_id == 2 && measure_3_id == 10 ||
                          measure_2_id == 12 && measure_3_id == 2 ||
                          measure_2_id == 5 && measure_3_id == 10 ||
                          measure_2_id == 12 && measure_3_id == 5) {
                       var measure_psmv_id  = measure_3_psmv_ids[h];
                       var athlete_data     = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                       var measure_reps     = Number(measure_2[h]); //reps_val;
                       var obj_lgth         = Object.keys(athlete_data).length;

                       if(obj_lgth > 0) {
                             measure_reps = Number(athlete_data.metric_b); // ie Reps     = id 2
                       } else {
                             measure_reps = Number(measure_2[h])
                       }

                       same_vals_arr.push(measure_reps)
                }
            }

            ////  Used to track the counter if user clicks on Save Entire Block  ////
            save_all_key_ctr_block_ids.push([block_id,key_ctr]);

            //////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////

            var all_same_reps = allEqual(same_vals_arr); // true | false
            var cmark_ctr = 0;
            for(var i = 0; i < total_sets; i++) { //for(var i = 1; i < total_sets; i++) {

                    // check if measure_2[i] is a numebr or a "Time(min:sec)" value
                    var measure_2_temp = measure_2[i];

                    // If measure_2_temp is a "time" change it to a number value
                    if(isNaN(measure_2_temp)) {
                        measure_2_temp = this.convertTimeMMSS(measure_2[i]); // ie convert 1 min to 60 secs
                    }
                    var measure_a      = ""; // weight: always 0 at the beginning of every new workout
                    var measure_b      = Number(measure_2_temp); //measure_b_value;
                    var measure_psmv_id= measure_2_psmv_ids[i]; //
                    var measure_c      = measure_3[i];
                    var measure_d_rest = measure_rest[i];
                    var measure_psm_id = measure_psm_ids[i*total_sets];
                    set_number = i+1;

                    //console.log("================= CHECK Predictive Loading ==============");
                    /*console.log("============  BEGIN ROW  ===========");
                    console.log("1. LBs measure_a: " + measure_a);
                    console.log("1. Reps measure_b: " + measure_b);
                    console.log("1. % max measur c: " + measure_c);*/

                    //// SHORTEN Certain Category Names ////
                    if(measure_2_id == 10) measure_2_title = "LBs";
                        else measure_2_title = getMeasureTitle(measure_2_id);

                    if(measure_3_id == 2) measure_3_title = "REPS";
                        else measure_3_title = getMeasureTitle(measure_3_id);

                    if(measure_2_id == 2 && measure_3_id == 12 ||
                       measure_2_id == 5 && measure_3_id == 12)  {
                            // ID 2  = Reps
                            measure_2_title = "LBs";
                            // ID 12 = % of Max
                            measure_3_title = "REPS";

                            if(measure_2_id == 5) measure_3_title = "REPS PER SIDE";
                            // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                            // If % of Max is selected on the Admin side, that will always be used in the calculation first;
                            /*var reps_val = measure_c; // measure c is % of max value
                            var percent  = "."+measure_c; //getPercent1RM(reps_val);

                            // New Measure A value derived from Predictive Loading formula
                            measure_a = Math.round(one_rep_max * percent); // Rounds UP if .5+ or DOWN if .5-
                            */

                            // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                            // If % of Max is selected on the Admin side, that will always be used in the calculation first;
                            var reps_val      = measure_c; // measure c is % of max value
                            var percent       = "."+measure_c; //getPercent1RM(reps_val);
                            if(measure_c > 99) percent = measure_c/100; // in case % of max is > 100; ie 100% = 1 || 150% = 1.5

                            // New Measure A value derived from Predictive Loading formula
                            measure_a = Math.round(one_rep_max * percent); // Rounds UP if .5+ or DOWN if .5-

                     } else if(measure_2_id == 12 && measure_3_id == 2 ||
                               measure_2_id == 12 && measure_3_id == 5) { // } || measure_2_id == 10 && measure_3_id == 2)  {
                           // ID 2  = Reps
                           measure_2_title = "REPS";
                           // ID 12 = % of Max
                           measure_3_title = "LBs";

                           if(measure_3_id == 5) measure_2_title = "REPS PER SIDE"
                           // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                           // If % of Max is selected on the Admin side, that will always be used in the calculation first;
                           var reps_val = measure_b; // measure c is % of max value
                           var percent  = "."+ measure_b;//getPercent1RM(reps_val);

                           measure_a = measure_c;
                           // New Measure B value derived from Predictive Loading formula
                           measure_b = Math.round(one_rep_max * percent); // Rounds UP if .5+ or DOWN if .5-
                    } else {
                            //console.log("Don't calc 1RM");
                            // Apply the different measures to new measure vars
                            measure_a = measure_b;
                            measure_b = measure_c;
                    }

                    //////////////////////////// PRE-EXISTING ATHLETE DATA /////////////////////////
                    ////    Check If There's a Matching Metric ID, if there is, display it      ////
                    var athlete_data      = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                    var athlete_perm_data = getExistingAthleteMetrics(measure_psmv_id, perm_athlete_metrics);
                    var obj_lgth      = Object.keys(athlete_data).length;
                    var obj_perm_lgth = Object.keys(athlete_perm_data).length;

                    /****************************** END - Predictive Loading Conversion ****************************/

                    //// Measure Id 20: Time (MM:SS) needs to be converted to seconds
                    //// rev 3/27
                    if(measure_2_id === 20 || measure_2_id === 21) {
                        var val = measure_2[i];
                        var new_val = val.indexOf(":");

                        // if val = -1, No need to convert time since it is already in Seconds only
                        if(new_val == "-1") {
                            measure_a = parseInt(val);//this.convertTimeMMSS(val);
                        } else {
                            // Convert MM:SS into Seconds only
                            measure_a = this.convertTimeMMSS(val);
                        }

                        // Change TIME (MIN:SEC) category title to "Seconds"; this is a temp solution since we don't add seconds to the MM:SSS format yet //
                        measure_2_title = "Seconds";
                    }

                    //// Measure Id 21: Seconds
                    //// rev 3/27
                    if(measure_3_id === 20 || measure_3_id === 21) {
                        var val = measure_3[i];
                        var new_val = val.indexOf(":");

                        // if val = -1, No need to convert time since it is already in Seconds only
                        if(new_val == "-1") {
                            measure_b = parseInt(val);
                        } else {
                            // Convert MM:SS into Seconds only
                            measure_b = this.convertTimeMMSS(val);
                        }

                        // Change TIME (MIN:SEC) category title to "Seconds"; this is a temp solution since we don't add seconds to the MM:SSS format yet //
                        measure_3_title = "Seconds";
                    }

                    // IF Obj Lgth is above 0, then there's a Match! //
                    // Replace new data with existing data           //
                    // rev 3/27
                    if(obj_lgth > 0) {
                        if(measure_2_id === 20)
                            measure_a = parseInt(athlete_data.metric_a); //this.convertTimeMMSS();
                        else {
                            measure_a = Number(athlete_data.metric_a); // ie Weight   = id 10
                            tmp_measure_a = measure_a;

                            var measure_b_tmp = Number(athlete_data.metric_b); // ie Weight   = id 10
                            tmp_measure_b = measure_b_tmp;
                        }

                        measure_b = Number(athlete_data.metric_b); // ie Reps     = id 2
                    }                                              // ie % of Max = id 12

                    ////  If the previous set has a higher value than the current set, use the higher measure value  ////
                    //if(measure_2_id != 20 && measure_2_id != 21 && tmp_measure_a > measure_a)
                        //measure_a = tmp_measure_a;

                    ////  If the previous set has a higher value than the current set, use the higher measure value  ////
                    //  Removes the ability to replace lower values with higher values
                    //  All sets that are the same (ie 5 sets, 5 sets, 5 sets) replace lower values with higher values
                    /**********  Below code was commented out because it was blocking the Predictive Loading logic  ********/
                    /**********  keeping it in just in case we want to use a variation of it later
                    if(measure_2_id == 2 && measure_3_id == 12 && tmp_measure_a > measure_a && all_same_reps) {
                        // Ie:  Lbs x Reps
                        measure_a = tmp_measure_a;
                    } else if(measure_2_id == 2 && measure_3_id == 10 && tmp_measure_b > measure_b && all_same_reps) {
                        // Ie:  Reps x Lbs
                        measure_b = tmp_measure_b;
                    } ************/

                    // IF Obj Lgth is above 0, then there's a Match! //
                    // Replace new data with existing data           //
                    //var ak_arr = this.state.activeKeyArr;
                    //var index_ak = ak_arr.indexOf(i);

                    var cmark = "checkmark_gray";

                    if(obj_perm_lgth > 0) {
                        cmark_ctr++;

                        track_compl_set_ids_per_block.push(new_set_id);
                        track_measure_psmv_id_arr.push(measure_psmv_id); // track ids for "Saving a Set" in the db
                        //console.log("CHECK GREEN > measure_psmv_id: " + measure_psmv_id);
                        // If there's existing data, mark it in the accordion view!
                        cmark = "checkmark_green";
                    }


                    var measure_d = measure_rest[i].toString(); //this.convertMMSS(measure_rest[i].toString());

                    panel_arr.push(<Panel key = {uniqueId()} eventKey={i}>
                                          <Panel.Heading style={{backgroundImage: `url(${PanelHeaderBkgrd})`, borderRight:4, borderLeft:"0px"}} >
                                              <Panel.Title className="workoutDetailsTitle workoutAllExercPanelTitleProductTour" toggle>
                                                    <span className="workoutDetailsPanelLeft">Set {set_number} {/*block_id*/}</span> { /* Set = measure_1_id, but we don't use it since it's static currently */ }
                                                    <span className="workoutDetailsPanelCenter">{measure_a} { measure_2_title } &nbsp;&nbsp;x &nbsp; {measure_b} {measure_3_title} </span>
                                                    <span className="workoutDetailsPanelRight"
                                                          onClick={(e) => this.handleCompleteCheckmark(e)}>
                                                          <img src={require('../../images/utils/'+cmark+'.png')} width="26"/>
                                                    </span>
                                              </Panel.Title>
                                          </Panel.Heading>
                                          <Panel.Body collapsible key={uniqueId()} className="workoutDetailsBodyPanel">
                                              <div key={uniqueId()} className="workoutDetailsAccordionPane" style={{height:265}}>
                                                <PanelMeasureAddSubtract saveSingleSetMetricData = {this.saveSingleSetMetricData}
                                                                         set_id          = { new_set_id }
                                                                         block_id        = { block_id }
                                                                         panel_ctr       = { i }
                                                                         panel_group_ctr = { key_ctr }
                                                                         exercise_id     = { exercise_id }
                                                                         measure_id      = { measure_id }
                                                                         measure_a_value = { measure_a }
                                                                         measure_b_value = { measure_b }
                                                                         measure_c_value = { measure_c } /* % of max note to left of Save btn */
                                                                         measure_rest    = { measure_d }
                                                                         psmv_id         = { measure_psmv_id }
                                                                         measure_a_id    = { measure_2_id } /* measure 1 is static: Set*/
                                                                         measure_b_id    = { measure_3_id }
                                                                         measure_2_title = { measure_2_title }
                                                                         measure_3_title = { measure_3_title }
                                                                         changeMetricValue = { this.changeMetricValue } />
                                                </div>
                                          </Panel.Body>
                                    </Panel> )

                    //// Used for the "Save All" function
                    save_all_metric_set_numbers.push(set_number);
                    save_all_metric_set_ids.push(new_set_id);
                    save_all_metric_exercise_ids.push(exercise_id);

                    save_all_metric_a_vals.push(measure_a);
                    save_all_metric_b_vals.push(measure_b);

                    save_all_metric_a_ids.push(measure_2_id);
                    save_all_metric_b_ids.push(measure_3_id);
                    save_all_metric_psmv_ids.push(measure_psmv_id);
            }

            var block_finished = false;
            if(parseInt(cmark_ctr) === parseInt(total_sets)) block_finished = true

            save_all_exercise_vals[key_ctr] = [save_all_metric_set_numbers, save_all_metric_set_ids, save_all_metric_exercise_ids, save_all_metric_a_vals, save_all_metric_b_vals, save_all_metric_a_ids, save_all_metric_b_ids, save_all_metric_psmv_ids]
            save_all_exercise_1rm.push(0); // 1 Rep Max
            //handleCompleteSet();

            panel_arr.push(<SaveAllExerciseRow key = {uniqueId()}
                                               block_finished = {block_finished}
                                               handleSubmitCheckAll={this.handleSubmitCheckAll.bind(this, key_ctr, block_id)}//, save_all_metric_set_numbers, save_all_metric_a_vals, save_all_metric_b_vals,  save_all_metric_a_ids, save_all_metric_b_ids, save_all_metric_psmv_ids, save_all_metric_set_ids, save_all_metric_exercise_ids )}
                           />)

            return panel_arr;
    }

    convertTimeMMSS(val) {
        var tmp_measure_a = val;
        //var hms = '02:04:33';   // your input string
        var a = tmp_measure_a.split(':'); // split it at the colons

        //console.log("a0: " + a[0]);
        //console.log("a1: " + a[1]);
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        var measure_a = (Number(a[0]) * 60) + Number(a[1]);

        return measure_a;
    }

    //// ADD TO A SEPARATE UTILS FILE ////
    convertMMSS (totalSeconds) {
          var hours   = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
          var seconds = totalSeconds - (hours * 3600) - (minutes * 60);

          // round seconds
          seconds = Math.round(seconds * 100) / 100

          /* incl hours
              var result = (hours < 10 ? "0" + hours : hours);
              result += ":" + (minutes < 10 ? "0" + minutes : minutes);
              result += ":" + (seconds  < 10 ? "0" + seconds : seconds);*/
              var result = (minutes < 10 ? "0" + minutes : minutes);
                  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
          return result;
    }

    handleCompleteCheckmark = event => {
        event.preventDefault();
    }

    getSeconds(mmss) {
        var a = mmss.split(':'); // split it at the colons
        //console.log("mmss: " + mmss);
        //console.log("split: " + a);
        var seconds = ((a[0]) * 60 + (+a[1]));

        //console.log("Total secs: " + seconds);
        return seconds;
    }


     convertMMSS (totalSeconds) {
          var hours   = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
          var seconds = totalSeconds - (hours * 3600) - (minutes * 60);

          // round seconds
          seconds = Math.round(seconds * 100) / 100

          /* incl hours
              var result = (hours < 10 ? "0" + hours : hours);
              result += ":" + (minutes < 10 ? "0" + minutes : minutes);
              result += ":" + (seconds  < 10 ? "0" + seconds : seconds);*/
              var result = (minutes < 10 ? "0" + minutes : minutes);
                  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
          return result;
    }


    getExerciseName = (exercise_id) => {
        //var exercise_ids = [];
        //var exercise_names = [];
        var names = this.state.names;

        for(var key in names) {
            //console.log("Names: " + names[key].name);
            //console.log("id: " + names[key].uid);
            var uid = names[key].uid;
            var name = names[key].name;
            if(exercise_id === uid) return name;
            //exercise_ids.push(names[key].uid);
            //exercise_names.push(names[key].name);
        }
    }

    handleCompleteSet = () => {
        console.log("handleCompleteSet");
    }

    renderSetList() {
        var programs = [];
        var title              = this.state.title;
        var week_tracker       = this.state.week_tracker;
        var curr_week          = this.state.curr_week;
        var curr_day           = this.state.curr_day;
        var program_id         = this.state.program_id;
        var list               = this.state.list;
        var exercise_notes     = this.state.exerciseNotes;
        var exerciseIdsInNotes = this.state.exerciseIdsInNotes
        var yt_id    = "";

            total_blocks  = list.length; // 4 = total number of measurements, ie sets/reps/% of max/rest
        var metric_data = this.state.metric_data;
            track_measure_psmv_id_arr     = []; // reset and track when a block is finished
            track_compl_set_ids_per_block = [];
            track_total_set_ids_per_block = [];
        var tmp_block_id;
        var block_ctr = 1;


        var yt_ids = this.state.yt_ids;
            save_all_exercise_vals = [];
            save_all_exercise_1rm  = [];
        var perm_athlete_metrics = this.state.perm_athlete_metrics;

        ////  1RM: COMPARE DATES OF EXISTING 1RM WITH TODAY's DATE, USE EXISTING 1RM IF IT MATCHES TODAY  ////
        let now = new Date();
        var curr_month  = now.getMonth()+1;
        var curr_day    = now.getDate();
        var curr_year   = now.getFullYear();
        var todays_date = curr_month+"-"+curr_day+"-"+curr_year

        for(var key in list) {
            //console.log("-----------------------");
            var list2       = list[key];
            var name        = list2.name;
            var set_id      = list2.set_id;
            var exercise_id = list2.exercise_id;
            var block_id    = list2.block_id;
            var measure_id  = list2.measure_id;
            var notes       = list2.notes;


            var exercise_name = this.getExerciseName(exercise_id);
            var cmark        = "checkmark_gray";
            var cmark_block  = "gray";
            var panel_header = "";

            ////////////////////////////////////////
            ////        Get YouTube Id          ////
            for(var y in yt_ids) {
                var tmp_yt = yt_ids[y];
                if(exercise_id === tmp_yt.exercise_id)
                    yt_id = tmp_yt.youtube_id;
            }

            if(yt_id === "") yt_id = 0;

            var one_rep_history =  <span className="workoutMetrics1RMLabel workoutAllExerc1RMHistoryProductTour"
                                         href={`/exercisehistory/${title}/${curr_week}-${curr_day}/${program_id}/${exercise_id}/${yt_id}`}
                                         onClick={this.handleGenericClick}
                                         style={{color: MainColor}}>
                                            1RM History
                                     </span>
            if(ExerciseFreeFormId === exercise_id) one_rep_history = ""; // Do not show 1 rep history

            //////////////////////////////////////////////////////////
            ////        CHECK If Exercises are Completed          ////
            var total_exercises = this.getTotalSets(set_id);
            var measure_2_psmv_ids = [];
            var total_cats =  total_exercises*2;
            var ctr_s = 0;

            for(var key_m in metric_data) {
                var list3      = metric_data[key_m];
                var tmp_set_id = list3.set_id;

                if(tmp_set_id == set_id) {
                    if(ctr_s < total_cats) {
                        var psmv_id    = list3.psmv_id;
                        measure_2_psmv_ids.push(psmv_id);

                        var athlete_perm_data = getExistingAthleteMetrics(psmv_id, perm_athlete_metrics);
                        var obj_perm_lgth = Object.keys(athlete_perm_data).length;
                    }
                    ctr_s++;
                }
            }

            var ctr_t = 0;
            var m_lgth = measure_2_psmv_ids.length;

            for(var t = 0; t < m_lgth; t++) {
                var measure_psmv_id = measure_2_psmv_ids[t]

                var athlete_perm_data = getExistingAthleteMetrics(measure_psmv_id, perm_athlete_metrics);
                var obj_perm_lgth = Object.keys(athlete_perm_data).length;

                if(obj_perm_lgth > 0) ctr_t++
            }

            ////  This conditional is used to turn the Exercise checkmark green, not the individual set id checkmarks  ////

            if(total_exercises === ctr_t && ExerciseFreeFormId != exercise_id) {
                total_completed_blocks++;
                // If there's existing data, mark it in the accordion view!
                cmark = "checkmark_green";
            }

            var completed_blocks = this.state.completed_blocks;
//            console.log("completed_blocks.length: " + completed_blocks.length);
            if(completed_blocks.length > 0) {
                var block_completed = completed_blocks.indexOf(block_id);

                if(block_completed >= 0) {
                    //total_completed_blocks++; // this does not count all checked sets
                    //console.log("set_id: " + set_id  + " - block completed: " + total_completed_blocks);

                    cmark_block = "green";

                    if(ExerciseFreeFormId === exercise_id) {
                        //  Exercise free-form is completed, add a total block  //
                        total_completed_blocks++;
                    }
                    cmark       = "checkmark_green"; // used for free-form blocks
                }
            }

            ////     END: CHECK If Exercises are Completed       ////
            /////////////////////////////////////////////////////////

            if(tmp_block_id != block_id) {
                var block_name   = list2.block_name;

                if(block_name === null)
                    block_name = "Block " + block_ctr++;

                var panel_header = <Panel.Heading   style={{display: "inline-block", color: "white", whiteSpace: "nowrap", backgroundColor: "#333", width:"100%", height: "45px", fontSize:"20px"}}>
                                        <span style={{display:"inline-block", width:"86%", textOverflow:"ellipsis", overflow: "hidden" }}>
                                            { block_name }
                                        </span>
                                        <Panel.Title className="workoutMetricsTitle" /*toggle*/>
                                              <span className="workoutMetricsMainPanelRight"
                                                    onClick={(e) => this.handleCompleteCheckmark(e)}>
                                                    <span className   = "workoutMetricsSquareBlock workoutAllExercSaveAllCMarkProductTour"
                                                          exercise_id = {exercise_id}
                                                          block_id    = {block_id}
                                                          set_id      = {set_id}
                                                          onClick     = {(e) => this.handleSaveEntireBlock(e)}
                                                    >

                                                        <img src={require('../../images/utils/checkmark_sq_'+cmark_block+'.png')} width="26"/>
                                                    </span>
                                                    { /*}<span onClick={(e) => this.handleSaveEntireBlock(e)} block_id={block_id} style={{cursor: "pointer", color:"white"}}>
                                                        Save Block
                                                    </span>*/ }
                                              </span>
                                        </Panel.Title>
                                    </Panel.Heading>
            }

            programs.push( <Panel key = { uniqueId() } eventKey={key} >
                                        { panel_header }
                                      <Panel.Heading style={{padding:"30px", position:"relative", top:-2, height:40, borderRight:4, borderLeft:"0px", backgroundColor: "#777"}} >
                                          <Panel.Title className="workoutDetailsTitle" toggle>
                                                <span className="workoutDetailsPanelLeft" style={{position:"relative", top:"-15px", left:"-10px", color:"white", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",textAlign:"left",height:20, width:"90%"}}>
                                                    { parseInt(key) + 1 } . { exercise_name } { /*set_id /*exercise_id*/ }
                                                </span>
                                                <span className="workoutDetailsPanelCenter-old">
                                                        {/*}<span className="workoutMetricsAthleteLabel"
                                                              onClick={this.handleShowAthleteNotes}>
                                                              <FontAwesomeIcon icon="sticky-note" /><span style={{paddingRight:7}}/>Athlete Notes
                                                        </span>*/}

                                                </span>
                                                <span className="workoutMetricsPanelRight"
                                                      onClick={(e) => this.handleCompleteCheckmark(e)}>
                                                      <span style={{position:"relative", left:-20}}>
                                                          <img src={require('../../images/utils/'+cmark+'.png')} width="26"/>
                                                      </span>
                                                </span>
                                          </Panel.Title>
                                      </Panel.Heading>
                                       { this.getExercises (key, block_id, set_id, exercise_id, exercise_name, one_rep_history, yt_id, notes, exerciseIdsInNotes, todays_date) }
                                </Panel>
                    )
                tmp_block_id = block_id;
        }

        var workout = <span style={{display: "inline-block", width: "100%"}}>
                            <span className="workoutMetricsPanelGroup">
                                <PanelGroup accordion
                                            id="accordion"
                                            defaultActiveKey = "0"
                                            //activeKey={this.state.activeKey}
                                            //onSelect={this.handleSelect.bind(this)} // onSelect removes the accordion animation
                                            className="panel-group"
                                            collapsible = "true"
                                          >
                                        { programs }
                                </PanelGroup>
                                <br/><br/>
                            </span>
                      </span>

        return workout;
    }

    getExercises (key, block_id, set_id, exercise_id, exercise_name, one_rep_history, yt_id, free_form_notes, exerciseIdsInNotes, todays_date) {
        var exercise_data;
        var exercise_body;
        var history;
        var notes;
        var button_text = "Mark as Complete";
        var button_color = MainColor;

        var notes_exist = exerciseIdsInNotes.indexOf(exercise_id);

        if(notes_exist != -1)
            notes = <span className = "workoutMetricsNotesLabel"
                          onClick   = { (evt) => this.handleShowNotes(exercise_id, exercise_name) } >
                         <FontAwesomeIcon icon="edit" className="" style={{ position:"relative", top:"0px" }}/>
                         &nbsp;Notes
                    </span>

        var body = <span>
                        <PanelGroup accordion
                                    id= "accordion"
                                    //onSelect={this.handleSelect.bind(this)} // onSelect removes the accordion animation
                                    className   = "panel-group"
                                    collapsible = "true"
                        >
                                     <div  className="workoutMetricsAthleteLabel workoutAllExercAthleteNotesProductTour"
                                           onClick={ (evt) => this.handleShowAthleteNotes(exercise_id, exercise_name) }
                                           style= {{height:"26px", color: "#666"}}>
                                           <FontAwesomeIcon icon="sticky-note" /><span style={{paddingRight:7}}/>Athlete Notes

                                     </div>
                                     { /* spacing below "notes" link */ }
                                     <span style= {{display: "block", height:"14px"}}></span>
                                     <span style={{position:"relative", top:15}}>
                                         { this.renderExerciseList(key, this.handleCompleteSet, block_id, set_id, exercise_id, exercise_name, todays_date) }
                                     </span>
                       </PanelGroup>
                       <span className="workoutMetricsPanelFooter">
                           { one_rep_history }
                           <span className="workoutMetricsNotesContainer">
                               { notes }
                           </span>
                           <span className = "workoutMetricsYouTubeLabel workoutAllExercYouTubeProductTour"
                                 onClick   = { this.handleShowModalWin.bind(this, yt_id, exercise_name) } >

                                 <FontAwesomeIcon icon={['fab', 'youtube']} className="" style={{ color: MainColor, position:"relative", top:"2px", right:"9px"}}/>
                                 { /*}<span className="glyphicon glyphicon-play-circle workDetailsYoutubeGlyph"/>*/ }
                                 <span style={{ color: MainColor, position:"relative", top:"1px", right:"5px"}}>
                                     YouTube
                                 </span>
                           </span>
                       </span>
                   </span>

            if(ExerciseFreeFormId === exercise_id) {
                    // ENSUER free form is compelted: total_completed_blocks++;
                    /*if(this.state.freeform_saved) {
                        button_text  = "Free-form Completed";
                        button_color = "#5b9f38";
                    }*/
                    //var free_form_notes = "<p>Placeholder notes: Lorem ipsum dolor sit amet, eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>"
                    exercise_data = <div className="freeFormMetricsHTMLBody" dangerouslySetInnerHTML={this.createMarkup(free_form_notes)} />;
                    exercise_body = <div onClick={(evt) => this.saveFreeFormData(evt, exercise_id, set_id, block_id)} className="workoutDetailSaveFreeFormBtn">
                                          <LoaderButton
                                              block
                                              height   = "40px"
                                              fontSize = "17px"
                                              type     = "submit"
                                              width    = "220px"
                                              btncolor = { button_color }
                                              isLoading= {this.state.isLoading}
                                              text     = { button_text }
                                              loadingText="Saving data…"
                                            />
                                    </div> // there is no exercise body with Free Form exercises

                    body = <span className="freeFormWorkoutMetrics">
                                { exercise_data }
                                { exercise_body }
                            </span>
            }

            return (  <Panel.Body collapsible key={uniqueId()} className="workoutDetailsBodyPanel">
                            { body }
                            <span style={{position:"absolute", top:-2, left:0, zindex:1000, display: this.state.showBodyPanelOverlay, opacity:.25, width:"100%", height:"100%", backgroundColor: "#000"}}/>
                       </Panel.Body>
            )
        }

    saveFreeFormData = (event, exercise_id, set_id, block_id) => {
            event.preventDefault();

            var measure_id  = 0; //this.state.measure_id;
            var metric_a    = 0;
            var metric_b    = 0;
            var metric_a_id = 0;
            var metric_b_id = 0;
            var set_number  = 0;
            // var set_id      = this.state.set_id;
            var panel_group_ctr = null;
            //var block_id        = null;
            // PSMV UID can't be a randomly generated uuid since it needs to be referenced in the database (insert or update) in case the user
            // hit's the save button multiple times. Solution is to give any free-form exercise it's own unique id so it can be refereneced in
            // the PSM and PSMV DB tables; basically, treat the free-form exercise as if it were given ids like any other exercise in the advanced
            // Metrics Modal view
            var psmv_id     = uuidv4(); // this can be any uuid; it's required in the DB since there's a foreign key associated with it

            this.saveSingleSetMetricData(set_id, exercise_id, set_number, measure_id, metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, panel_group_ctr, block_id);//, this.endFreeFormExercise);
    }

    endFreeFormExercise = () => {
        // don't need to go back on this pave
        // this.props.history.goBack();
    }

    changeMetricValue = (set_number, measure_a_value, measure_b_value, panel_group_ctr) => {

        var metric_set_numbers  = save_all_exercise_vals[panel_group_ctr][0]; //metric_set_numbers
        var metric_set_ids      = save_all_exercise_vals[panel_group_ctr][1];
        var metric_exercise_ids = save_all_exercise_vals[panel_group_ctr][2];
        var metric_a_vals       = save_all_exercise_vals[panel_group_ctr][3];
        var metric_b_vals       = save_all_exercise_vals[panel_group_ctr][4];
        var metric_a_ids        = save_all_exercise_vals[panel_group_ctr][5];
        var metric_b_ids        = save_all_exercise_vals[panel_group_ctr][6];
        var metric_psmv_ids     = save_all_exercise_vals[panel_group_ctr][7];

        var tmp_lgth = save_all_exercise_vals[panel_group_ctr][3].length;
        var tmp_arr_a = [];
        var tmp_arr_b = [];

        //// Remove the OLD Metric Value and add in the NEW Value
        for(var t = 0; t < tmp_lgth; t++) {
            var val_a, val_b;
            if(t === set_number) {
                val_a = measure_a_value;
                val_b = measure_b_value;
            } else {
                val_a = save_all_exercise_vals[panel_group_ctr][3][t];
                val_b = save_all_exercise_vals[panel_group_ctr][4][t];
            }

            tmp_arr_a.push(val_a);
            tmp_arr_b.push(val_b);
        }

        save_all_exercise_vals[panel_group_ctr][3] = tmp_arr_a;
        save_all_exercise_vals[panel_group_ctr][4] = tmp_arr_b;
    }


    handleSaveEntireBlock = async event => {
            //e.preventDefault();

            this.setOverlayState("overlay", "save");

            var block_id    = event.currentTarget.getAttribute("block_id");
            var set_id = event.currentTarget.getAttribute("set_id");
            var exercise_id = event.currentTarget.getAttribute("exercise_id");

            var key_ctr         = 0;
            var number_of_exerc = 0;
            var lgth            = save_all_key_ctr_block_ids.length;
            var key_ctr_arr     = [];

            ////  GET "KEY CTR" from array based off of original Block Id   ////
            ////  This will retrieve the correct value in the global array  ////
            for(var i=0; i < lgth; i++) {
                var tmp_id = save_all_key_ctr_block_ids[i][0]; // [0]: block id & [1]: key ctr
                if(tmp_id === block_id) {
                    number_of_exerc++
                    var key_ctr = save_all_key_ctr_block_ids[i][1];
                    key_ctr_arr.push(key_ctr)
                }
            }

            var block_arr;

            ////  If the block is a free-form block, add manual values
            if(ExerciseFreeFormId === exercise_id)
                block_arr = this.convertFreeFormValsToArray(block_id, set_id);
            else
                block_arr = this.convertMetricValsToArray(number_of_exerc, key_ctr_arr, block_id);

            var results   = await this.setSaveEntireBlock(block_arr);
            this.asyncDone(results);
    }

    convertFreeFormValsToArray (block_id, set_id) {

        var user_id             = this.props.globalUserId;
        var metric_set_numbers  = 0;
        var metric_set_ids      = [set_id]; // must be in array since on back-end it looks for [0] el
        var metric_exercise_ids = [ExerciseFreeFormId];
        var metric_a_vals       = 0;
        var metric_b_vals       = 0;
        var metric_a_ids        = 0;
        var metric_b_ids        = 0;
        var metric_psmv_ids     = 0;
        var program_id          = this.state.program_id;
        var block_arr           = [];

        block_arr.push([user_id, metric_set_numbers, metric_set_ids, metric_exercise_ids, metric_a_vals, metric_b_vals, metric_a_ids, metric_b_ids, metric_psmv_ids, program_id, block_id]);

        return block_arr;
    }

    setSaveEntireBlock = async (metric_arr) => {
        var metrics = [];
        var results = await invokeSetAthleteExerciseSaveAllMetricsVers2(metric_arr);
        return results;
    }

    convertMetricValsToArray(arr_lgth, key_ctr_arr, block_id) {
        var block_arr  = [];
        var program_id = this.state.program_id;

        for(var i = 0; i < arr_lgth; i++) {
            // ORDER of Array
            var user_id             = this.props.globalUserId;
            var metric_set_numbers  = save_all_exercise_vals[key_ctr_arr[i]][0]; //metric_set_numbers
            var metric_set_ids      = save_all_exercise_vals[key_ctr_arr[i]][1];
            var metric_exercise_ids = save_all_exercise_vals[key_ctr_arr[i]][2];
            var metric_a_vals       = save_all_exercise_vals[key_ctr_arr[i]][3]; //metric_a_vals
            var metric_b_vals       = save_all_exercise_vals[key_ctr_arr[i]][4]; //metric_b_vals
            var metric_a_ids        = save_all_exercise_vals[key_ctr_arr[i]][5];
            var metric_b_ids        = save_all_exercise_vals[key_ctr_arr[i]][6];
            var metric_psmv_ids     = save_all_exercise_vals[key_ctr_arr[i]][7];
            //  program_id
            //  block_id

            block_arr.push([user_id, metric_set_numbers, metric_set_ids, metric_exercise_ids, metric_a_vals, metric_b_vals, metric_a_ids, metric_b_ids, metric_psmv_ids, program_id, block_id]);
        }

        return block_arr;
    }

    handleSubmitCheckAll = async (key_ctr, block_id, event) => {
        this.setOverlayState("overlay", "save");

        //var results  = await invokeSetAthleteExerciseMetricsSaveAll(user_id, metric_set_numbers, metric_a_vals, metric_b_vals, metric_a_ids, metric_b_ids, metric_psmv_ids, metric_set_ids, metric_exercise_ids, program_id, block_id);
        var arr_lgth    = 1; // this function there will always be only 1 exercise for the "Save All" button
        var key_ctr_arr = [key_ctr]; // must add ctr to array for the Save All and Save Entire Block functionality to work
        var block_arr   = this.convertMetricValsToArray(arr_lgth, key_ctr_arr, block_id);

        var results     = await this.setSaveEntireBlock(block_arr);
        this.asyncDone(results);
    }

    asyncDone (results) {
        //// Multiple results so take the first el in array  ////
        if(results.status) {

            this.renderExerciseSetList();
            this.setOverlayState("no_overlay");
        } else
            this.setOverlayState("no_overlay");
    }

    setOverlayState (overlay, save_all_msg) {
        var loading_text = "Loading exercises...";
        if(save_all_msg == "save")
            loading_text = "Saving exercises...";

        if(save_all_msg === "save")
            this.setState({
                loadingText: loading_text,
                showBodyPanelOverlay: "inline",
                showModalLoadingInfo: true
            })
        else if(overlay === "no_overlay")
            this.setState({
                showBodyPanelOverlay: "none",
                pageOverlay: "none"
            })
        else if(overlay === "overlay")
            this.setState({
                loadingText: loading_text,
                pageOverlay: "inline"
            })
        else if(overlay === "double_overlay")
            this.setState({
                loadingText: loading_text,
                pageOverlay: "inline",
                showBodyPanelOverlay: "inline",
            })
        else if(overlay === "no_double_overlay")
            this.setState({
                pageOverlay: "none",
                showBodyPanelOverlay: "none",
            })
    }

    handleWorkoutDetails = event => {

        event.preventDefault();
        var href = event.currentTarget.getAttribute("href");
        this.props.history.push(href);
    }

    handleShowNotes = (exercise_id, name) => {
        var exercise_notes = this.state.exerciseNotes;
        var current_note;

        for(var key in exercise_notes) {
            var tmp_exerc_id = exercise_notes[key][0];
            if(exercise_id === tmp_exerc_id) current_note = exercise_notes[key][1];
        }

        this.setState({
            showModalExerciseNotes: true,
            currExerciseNote: current_note,
            exerciseName: name
        })
    }

    handleShowAthleteNotes = (exercise_id, exercise_name) => {
        this.setState({
            showModalExerciseAthleteNotes: true,
            exercise_id: exercise_id,
            exercise_name: exercise_name
        })
    }

    renderWorkoutList() {
        var exercise_data = this.renderSetList(); // Exercise names & data
        var exercise_body;
        var exercise_id = "";//this.state.exercise_id;
        var free_form_notes = this.state.free_form_notes;

        if(ExerciseFreeFormId === exercise_id) {
            exercise_data = <div style={{paddingLeft:20}} dangerouslySetInnerHTML={this.createMarkup(free_form_notes)} />;
            exercise_body = ""; // there is no exercise body with Free Form exercises
        }

        return (
            <span>
                        { exercise_data }
                        { exercise_body }
            </span>
        );
    }

    handleCloseModalWin = (action) => {
        this.setState({
            showModalWin: false
        });
    }

    handleShowModalWin = (yt_id, exercise_name) => {
        this.setState({
            showModalWin: true,
            curr_yt_id: yt_id,
            exerciseName: exercise_name
        });
    }

    workoutOverlay() {
        return <div style={{width:410, height: 228, borderRadius: 5, border:"2px solid #ccc", backgroundColor: "#666"}}>
                    <div style={{position:"relative", top:0}}>
                        <WorkoutFinishedBox
                              isLoading             = {this.state.isLoading}
                              handleHideOverlay     = { this.handleHideOverlay }
                              color                 = "white"
                              handleWorkoutFinished = {this.handleWorkoutFinished}
                        />
                    </div>
               </div>
    }

    ////  Begin: Show Help Tour  ////

    onExit = () => {
        this.setState(() => ({ stepsEnabled: false }));
    };

    showHelpTour = () => {
        this.setState(() => ({ stepsEnabled: true }));
    }

    ////  End: Show Help Tour  ////

    handleHideOverlay = event => {
        workout_box_overlay = "none"

        this.setState({
            pageOverlay: "none",
            showWorkoutBox: "none"
        })
    }

    render() {
        let closeModalExerciseNotes        = () => this.setState({ showModalExerciseNotes: false }); //close simple modal window
        let closeModalExerciseAthleteNotes = () => this.setState({ showModalExerciseAthleteNotes: false }); //close simple modal window
        let closeModalLoadingInfo          = () => this.setState({ showModalLoadingInfo: false }); //close simple modal window
        var loading_text = this.state.loadingText;

        const {
            stepsEnabled,
            steps,
            initialStep,
        } = this.state;

        return (
          <div className="HomeProgramWorkoutDetails">
              <span className = "workoutDetailMainIconHelpTour glyphicon glyphicon-question-sign"
                    onClick   = {this.showHelpTour}/>
              { this.renderList() }
              { /*this.props.isAuthenticated ? this.renderNotes() : this.renderLander()*/ }

                <div>
                    <span className="pageOverlay" style={{display: this.state.pageOverlay}} />
                    <span style={{display: this.state.showWorkoutBox}}>
                        <span style={{float:"left", position:"fixed", top:"20%", marginLeft:"50%", left:-200, display: workout_box_overlay, zIndex:10000}}>
                              { this.workoutOverlay() }
                        </span>

                        <StopWatch displayStopwatch={true} />
                    </span>

                  {this.state.showModalExerciseAthleteNotes ?
                      <ModalExerciseAthleteNotes
                          show          = { this.state.showModalExerciseAthleteNotes}
                          onHide        = { closeModalExerciseAthleteNotes}
                          exercise_id   = { this.state.exercise_id }
                          exercise_name = { this.state.exercise_name }
                      />
                  : null}

                  <ModalExerciseNotes
                      show          = { this.state.showModalExerciseNotes}
                      onHide        = { closeModalExerciseNotes}
                      notes         = { this.state.currExerciseNote }
                      exercise_name = { this.state.exerciseName }
                  />

                  <Modal
                         show={this.state.showModalWin}
                         onHide = {() => this.handleCloseModalWin("close")}
                         aria-labelledby="contained-modal-title"
                         style  = {{position: "absolute", top: 100}}
                       >
                         <Modal.Header closeButton>
                           <Modal.Title id="contained-modal-title">
                             Exercise Video: {this.state.exerciseName}
                           </Modal.Title>
                         </Modal.Header>
                         <Modal.Body>
                           <YouTubePlayer yt_id={this.state.curr_yt_id} />
                         </Modal.Body>
                         <Modal.Footer>
                             <span onClick={() => this.handleCloseModalWin("close")}
                                   style={{float:"right"}}>
                                 <LoaderButton
                                     block
                                     height   = "40px"
                                     fontSize = "17px"
                                     type     = "submit"
                                     width    = "100px"
                                     btncolor = { CloseBtnColor }
                                     text     = { "Close" }
                                   />
                              </span>
                         </Modal.Footer>
                   </Modal>
                   {this.state.showModalLoadingInfo ?
                     <ModalLoadingInfo
                         modalWidth    = { 300 }
                         modalHeight   = { 70 }
                         show          = { this.state.showModalLoadingInfo }
                         message       = { loading_text }
                         //onHide = { closeModalLoadingInfo }
                     />
                   : null}
            </div>

              <Steps
                  enabled={stepsEnabled}
                  steps={steps}
                  initialStep={initialStep}
                  onExit={this.onExit}
                  options= {{disableInteraction:true}}
              />
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/workout/WorkoutAllExercises.js